var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegratedSecurity = function SvgIntegratedSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 679 620"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__a)",
    d: "m368.483 549.838-22.447-5.811a.83.83 0 0 0-1.009 1.009l5.811 22.446a.828.828 0 0 0 1.493.246l2.908-4.451a.828.828 0 0 1 1.278-.132l10.614 10.613a.827.827 0 0 0 1.17 0l6.457-6.457a.827.827 0 0 0 0-1.17l-10.614-10.613a.827.827 0 0 1 .133-1.278l4.45-2.907a.827.827 0 0 0-.245-1.493z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M551.602 588.518a.6.6 0 0 1-.267-1.127 242 242 0 0 0 4.34-2.422.6.6 0 1 1 .596 1.042 240 240 0 0 1-4.36 2.434.6.6 0 0 1-.308.072zm8.647-4.943a.6.6 0 0 1-.288-1.115 248 248 0 0 0 4.235-2.596.6.6 0 1 1 .638 1.017 244 244 0 0 1-4.256 2.611.6.6 0 0 1-.329.085zm8.437-5.293a.6.6 0 0 1-.309-1.102c1.382-.906 2.77-1.838 4.126-2.768a.6.6 0 1 1 .679.989 252 252 0 0 1-4.146 2.783.6.6 0 0 1-.35.098m8.214-5.635a.6.6 0 0 1-.329-1.088 243 243 0 0 0 4.009-2.935.6.6 0 1 1 .72.961 246 246 0 0 1-4.029 2.95.6.6 0 0 1-.371.112m7.977-5.967a.599.599 0 0 1-.347-1.073 250 250 0 0 0 3.886-3.097.6.6 0 1 1 .758.931 252 252 0 0 1-3.906 3.112.6.6 0 0 1-.391.126zm7.728-6.287a.6.6 0 0 1-.367-1.058 237 237 0 0 0 3.757-3.253.602.602 0 0 1 .796.9 250 250 0 0 1-3.776 3.269.6.6 0 0 1-.41.142m7.466-6.599a.6.6 0 0 1-.386-1.042 249 249 0 0 0 3.622-3.404.6.6 0 1 1 .83.867 241 241 0 0 1-3.639 3.42.6.6 0 0 1-.428.159zm7.19-6.898a.6.6 0 0 1-.403-1.025 243 243 0 0 0 3.48-3.549.6.6 0 1 1 .866.832 250 250 0 0 1-3.497 3.567.6.6 0 0 1-.445.176zm6.903-7.186a.6.6 0 0 1-.42-1.007 247 247 0 0 0 3.333-3.688.6.6 0 1 1 .899.794 256 256 0 0 1-3.349 3.708.6.6 0 0 1-.463.192zm6.605-7.463a.602.602 0 0 1-.436-.989 249 249 0 0 0 3.179-3.822.601.601 0 0 1 .931.759 247 247 0 0 1-3.194 3.841.6.6 0 0 1-.48.211m6.295-7.728a.6.6 0 0 1-.452-.969 247 247 0 0 0 3.021-3.949.6.6 0 1 1 .96.72 245 245 0 0 1-3.035 3.968.6.6 0 0 1-.494.23m5.973-7.979a.6.6 0 0 1-.466-.949 244 244 0 0 0 2.855-4.071.601.601 0 0 1 .99.68 244 244 0 0 1-2.87 4.091.6.6 0 0 1-.509.25zm5.642-8.219a.602.602 0 0 1-.479-.929c.906-1.38 1.809-2.787 2.686-4.184a.6.6 0 0 1 1.016.639 230 230 0 0 1-2.7 4.204.6.6 0 0 1-.524.271zm5.299-8.443a.598.598 0 0 1-.492-.909c.851-1.42 1.696-2.864 2.512-4.292a.6.6 0 0 1 1.042.595c-.82 1.435-1.67 2.886-2.524 4.313a.6.6 0 0 1-.537.292zm4.948-8.656a.6.6 0 0 1-.505-.887 237 237 0 0 0 2.334-4.392.6.6 0 1 1 1.066.552 242 242 0 0 1-2.345 4.414.6.6 0 0 1-.549.313zm4.587-8.854a.6.6 0 0 1-.517-.865 241 241 0 0 0 2.151-4.485.6.6 0 0 1 1.088.507 240 240 0 0 1-2.161 4.509.6.6 0 0 1-.56.334zm4.218-9.034a.599.599 0 0 1-.527-.843c.668-1.513 1.328-3.05 1.961-4.567a.6.6 0 1 1 1.108.462c-.636 1.526-1.3 3.07-1.972 4.59a.6.6 0 0 1-.571.358zm3.839-9.197a.6.6 0 0 1-.538-.819c.604-1.536 1.2-3.098 1.771-4.645a.6.6 0 0 1 .771-.355c.31.115.469.46.355.771a246 246 0 0 1-1.78 4.667.6.6 0 0 1-.58.381zm3.454-9.348a.6.6 0 0 1-.547-.797c.54-1.559 1.07-3.144 1.577-4.714a.6.6 0 1 1 1.143.371 235 235 0 0 1-1.586 4.736.6.6 0 0 1-.588.404zm3.064-9.483a.6.6 0 0 1-.554-.772c.474-1.576.938-3.183 1.381-4.775a.6.6 0 0 1 1.157.321 241 241 0 0 1-1.388 4.799.6.6 0 0 1-.596.427m2.67-9.601a.6.6 0 0 1-.561-.748c.409-1.601.806-3.226 1.181-4.828a.599.599 0 1 1 1.169.273 246 246 0 0 1-1.188 4.852.6.6 0 0 1-.601.451m2.27-9.703a.6.6 0 0 1-.567-.725c.342-1.61.672-3.249.982-4.874a.6.6 0 1 1 1.179.226c-.311 1.632-.643 3.28-.986 4.897a.6.6 0 0 1-.608.475zm1.868-9.79a.603.603 0 0 1-.571-.7c.276-1.626.539-3.278.781-4.91a.6.6 0 1 1 1.188.176c-.243 1.64-.508 3.3-.785 4.934a.6.6 0 0 1-.613.5m1.466-9.858a.6.6 0 0 1-.576-.675c.21-1.635.405-3.297.58-4.937a.6.6 0 1 1 1.193.128 236 236 0 0 1-.583 4.962.6.6 0 0 1-.616.524zm1.06-9.91-.032-.001a.6.6 0 0 1-.546-.651c.142-1.645.269-3.313.378-4.956a.601.601 0 0 1 1.199.079 262 262 0 0 1-.38 4.982.6.6 0 0 1-.619.548zM34.995 191.697a.6.6 0 0 0 1.158-.034c.388-1.603.799-3.224 1.22-4.817a.601.601 0 0 0-1.16-.308c-.424 1.601-.837 3.23-1.227 4.841a.6.6 0 0 0 .01.317zm2.544-9.63a.6.6 0 0 0 1.151-.01c.454-1.581.93-3.184 1.416-4.761a.6.6 0 1 0-1.148-.354 247 247 0 0 0-1.423 4.785.6.6 0 0 0 .002.34zm2.937-9.518a.601.601 0 0 0 1.144.015c.52-1.569 1.061-3.15 1.61-4.701a.6.6 0 0 0-1.131-.4 250 250 0 0 0-1.619 4.723.6.6 0 0 0-.004.363m3.324-9.389a.6.6 0 0 0 1.136.037c.584-1.548 1.19-3.106 1.802-4.631a.6.6 0 1 0-1.115-.447 253 253 0 0 0-1.81 4.653.6.6 0 0 0-.013.388m3.707-9.247a.599.599 0 0 0 1.126.059 245 245 0 0 1 1.99-4.554.599.599 0 1 0-1.095-.492 250 250 0 0 0-2 4.577.6.6 0 0 0-.02.409zm4.08-9.089a.6.6 0 0 0 1.116.082 241 241 0 0 1 2.174-4.47.6.6 0 0 0-1.075-.536 247 247 0 0 0-2.184 4.491.6.6 0 0 0-.032.433m4.449-8.915a.6.6 0 0 0 1.106.103c.767-1.462 1.56-2.935 2.354-4.377a.6.6 0 0 0-1.052-.579 245 245 0 0 0-2.365 4.399.6.6 0 0 0-.043.455zm4.809-8.727a.602.602 0 0 0 1.094.125 239 239 0 0 1 2.53-4.278.6.6 0 0 0-1.027-.622 258 258 0 0 0-2.544 4.298.6.6 0 0 0-.055.476zm5.16-8.524a.6.6 0 0 0 1.082.146 242 242 0 0 1 2.703-4.171.6.6 0 0 0-1-.664 248 248 0 0 0-2.717 4.192.6.6 0 0 0-.067.497m5.506-8.307a.601.601 0 0 0 1.068.166 255 255 0 0 1 2.873-4.058.6.6 0 0 0-.974-.703 249 249 0 0 0-2.887 4.078.6.6 0 0 0-.08.517m5.842-8.076a.6.6 0 0 0 1.053.187c.99-1.312 2.012-2.636 3.036-3.937a.6.6 0 0 0-.943-.743 249 249 0 0 0-3.051 3.956.6.6 0 0 0-.095.537m6.168-7.829a.6.6 0 0 0 1.038.205 247 247 0 0 1 3.195-3.809.6.6 0 1 0-.912-.781 244 244 0 0 0-3.212 3.828.6.6 0 0 0-.11.557m6.484-7.572a.598.598 0 0 0 1.022.223 242 242 0 0 1 3.349-3.675.6.6 0 0 0-.88-.817 239 239 0 0 0-3.365 3.694.6.6 0 0 0-.127.576zm6.79-7.299a.599.599 0 0 0 1.005.241 241 241 0 0 1 3.498-3.534.6.6 0 1 0-.843-.853 248 248 0 0 0-3.516 3.551.6.6 0 0 0-.143.594zm7.086-7.014a.6.6 0 0 0 .988.259 238 238 0 0 1 3.641-3.388.6.6 0 0 0-.809-.887 237 237 0 0 0-3.659 3.404.6.6 0 0 0-.161.611zm7.37-6.716a.6.6 0 0 0 .969.276 239 239 0 0 1 3.779-3.235.6.6 0 0 0-.771-.92 244 244 0 0 0-3.798 3.25.6.6 0 0 0-.179.628m7.64-6.407q.033.108.107.2a.6.6 0 0 0 .844.092 238 238 0 0 1 3.906-3.073.6.6 0 1 0-.733-.951 244 244 0 0 0-3.926 3.09c-.197.158-.267.416-.197.643zm7.895-6.082q.029.096.091.181a.6.6 0 0 0 .839.127c1.328-.98 2.684-1.958 4.03-2.908a.601.601 0 0 0-.692-.98c-1.353.955-2.715 1.938-4.05 2.922a.6.6 0 0 0-.218.66zm8.14-5.749q.025.084.077.161a.6.6 0 0 0 .834.162 240 240 0 0 1 4.147-2.74.6.6 0 1 0-.652-1.008 239 239 0 0 0-4.167 2.753.6.6 0 0 0-.238.673zm8.371-5.408a.6.6 0 0 0 .889.336 243 243 0 0 1 4.257-2.566.601.601 0 0 0-.609-1.035 244 244 0 0 0-4.278 2.58.6.6 0 0 0-.259.685m8.587-5.056a.595.595 0 0 0 .867.349c1.442-.81 2.909-1.612 4.36-2.388a.6.6 0 0 0-.565-1.059c-1.458.78-2.932 1.588-4.381 2.4a.6.6 0 0 0-.281.698m8.789-4.697a.601.601 0 0 0 .847.36 243 243 0 0 1 4.454-2.207.6.6 0 1 0-.521-1.081 242 242 0 0 0-4.477 2.217.6.6 0 0 0-.302.71zm8.976-4.332a.602.602 0 0 0 .824.371 240 240 0 0 1 4.542-2.021.6.6 0 0 0-.477-1.103 247 247 0 0 0-4.564 2.032.6.6 0 0 0-.325.721m9.145-3.96q.008.028.019.053a.6.6 0 0 0 .782.33 238 238 0 0 1 4.621-1.834.595.595 0 0 0 .344-.776.6.6 0 0 0-.775-.344c-1.547.595-3.11 1.215-4.644 1.843a.6.6 0 0 0-.347.73zm9.302-3.581.009.03a.6.6 0 0 0 .769.36 247 247 0 0 1 4.692-1.644.6.6 0 1 0-.386-1.138 248 248 0 0 0-4.715 1.653.6.6 0 0 0-.37.74z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__b)",
    d: "M33 309.643c0-68.023 21.934-130.923 59.116-182.012C137.662 65.049 206.085 20.187 285.097 5.338A311.3 311.3 0 0 1 342.643 0c171.012 0 309.643 138.631 309.643 309.643 0 73.89-25.882 141.736-69.074 194.966-56.771 69.964-143.449 114.677-240.569 114.677-31.349 0-61.61-4.659-90.128-13.321-79.407-24.121-145.303-79.286-183.56-151.364C46.005 411.353 33 362.017 33 309.643",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD3D86",
    d: "M396.846 142H197.154c-4.503 0-8.154 3.189-8.154 7.122v293.756c0 3.933 3.651 7.122 8.154 7.122h199.692c4.503 0 8.154-3.189 8.154-7.122V149.122c0-3.933-3.651-7.122-8.154-7.122M549.009 133.752H425.788a8.135 8.135 0 0 0-8.135 8.135v168.16a8.135 8.135 0 0 0 8.135 8.135h123.221a8.135 8.135 0 0 0 8.135-8.135v-168.16a8.135 8.135 0 0 0-8.135-8.135",
    opacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M346.822 152.522H103.157c-6.419 0-11.623 5.204-11.623 11.624v330.476c0 6.42 5.204 11.624 11.623 11.624h243.665c6.42 0 11.624-5.204 11.624-11.624V164.146c0-6.42-5.204-11.624-11.624-11.624",
    opacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__c)",
    d: "M337.385 160.815H173.094c-7.982 0-14.453 6.471-14.453 14.454v305.966c0 7.983 6.471 14.454 14.453 14.454h164.291c7.982 0 14.453-6.471 14.453-14.454V175.269c0-7.983-6.471-14.454-14.453-14.454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.621 174.36H178.24a6.845 6.845 0 0 0-6.844 6.845V225.5a6.845 6.845 0 0 0 6.844 6.845h158.381a6.845 6.845 0 0 0 6.845-6.845v-44.295a6.845 6.845 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M228.681 183.496h-46.966v16.48h46.966z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M228.681 205.742h-46.966v16.48h46.966zM241.24 193.539c2.625 0 4.752-2.092 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.093-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M257.931 193.539c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.093-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.635 193.539c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.093-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M241.24 209.322c2.625 0 4.752-2.092 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.092-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M257.931 209.322c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M274.635 209.322c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673M330.711 186.273h-27.735v25.419h27.735z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.621 250.128H178.24a6.844 6.844 0 0 0-6.844 6.845v44.294a6.844 6.844 0 0 0 6.844 6.845h158.381a6.845 6.845 0 0 0 6.845-6.845v-44.294a6.845 6.845 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M228.681 259.263h-46.966v16.481h46.966z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M228.681 281.509h-46.966v16.481h46.966zM241.24 269.294c2.625 0 4.752-2.092 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.092-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M257.931 269.294c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.635 269.294c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M241.24 285.09c2.625 0 4.752-2.093 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.092-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M257.931 285.09c2.624 0 4.752-2.093 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M274.635 285.09c2.624 0 4.752-2.093 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M330.711 262.041h-27.735v25.418h27.735z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.621 325.883H178.24a6.844 6.844 0 0 0-6.844 6.845v44.294a6.845 6.845 0 0 0 6.844 6.845h158.381a6.845 6.845 0 0 0 6.845-6.845v-44.294a6.845 6.845 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M228.681 335.018h-46.966v16.48h46.966z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M228.681 357.264h-46.966v16.481h46.966zM241.24 345.062c2.625 0 4.752-2.092 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.092-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#644AEC",
    d: "M257.931 345.062c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.635 345.062c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#644AEC",
    d: "M241.24 360.844c2.625 0 4.752-2.092 4.752-4.672 0-2.581-2.127-4.673-4.752-4.673s-4.752 2.092-4.752 4.673 2.128 4.672 4.752 4.672"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M257.931 360.844c2.624 0 4.752-2.092 4.752-4.672 0-2.581-2.128-4.673-4.752-4.673-2.625 0-4.752 2.092-4.752 4.673s2.127 4.672 4.752 4.672"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#644AEC",
    d: "M274.635 360.844c2.624 0 4.752-2.092 4.752-4.672 0-2.581-2.128-4.673-4.752-4.673-2.625 0-4.752 2.092-4.752 4.673s2.127 4.672 4.752 4.672"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M330.711 337.809h-27.735v25.418h27.735z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.621 401.65H178.24a6.845 6.845 0 0 0-6.844 6.845v44.295a6.845 6.845 0 0 0 6.844 6.845h158.381a6.845 6.845 0 0 0 6.845-6.845v-44.295a6.845 6.845 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M228.681 410.786h-46.966v16.48h46.966z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M228.681 433.032h-46.966v16.48h46.966zM241.24 420.816c2.625 0 4.752-2.092 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.092-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#644AEC",
    d: "M257.931 420.816c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.635 420.816c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M241.24 436.612c2.625 0 4.752-2.092 4.752-4.673s-2.127-4.673-4.752-4.673-4.752 2.092-4.752 4.673 2.128 4.673 4.752 4.673"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M257.931 436.612c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#644AEC",
    d: "M274.635 436.612c2.624 0 4.752-2.092 4.752-4.673s-2.128-4.673-4.752-4.673c-2.625 0-4.752 2.092-4.752 4.673s2.127 4.673 4.752 4.673"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M330.711 413.563h-27.735v25.418h27.735z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M615.55 191.828H401.555c-6.42 0-11.623 5.204-11.623 11.623v291.158c0 6.42 5.203 11.624 11.623 11.624H615.55c6.419 0 11.623-5.204 11.623-11.624V203.451c0-6.419-5.204-11.623-11.623-11.623",
    opacity: 0.25
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__d)",
    d: "M410.269 496.86h142.808c7.982 0 14.453-6.471 14.453-14.453V213.666c0-7.982-6.471-14.453-14.453-14.453H410.269c-7.982 0-14.453 6.471-14.453 14.453v268.741c0 7.982 6.471 14.453 14.453 14.453"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M549.338 211.244H410.084a6.845 6.845 0 0 0-6.845 6.845v37.858a6.845 6.845 0 0 0 6.845 6.844h139.254a6.844 6.844 0 0 0 6.845-6.844v-37.858a6.845 6.845 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M505.268 234.03h41.741v-14.651h-41.741z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M547.008 239.137h-41.74v14.65h41.74zM494.105 228.277c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M479.27 228.277c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464.423 228.277c2.333 0 4.225-1.856 4.225-4.146s-1.892-4.147-4.225-4.147c-2.334 0-4.226 1.857-4.226 4.147s1.892 4.146 4.226 4.146"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M494.105 242.323c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479.27 242.323c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M464.423 242.323c2.333 0 4.225-1.857 4.225-4.147s-1.892-4.146-4.225-4.146c-2.334 0-4.226 1.856-4.226 4.146s1.892 4.147 4.226 4.147M414.586 244.441h24.655v-22.588h-24.655z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M549.338 278.587H410.084a6.845 6.845 0 0 0-6.845 6.845v37.857a6.845 6.845 0 0 0 6.845 6.845h139.254a6.844 6.844 0 0 0 6.845-6.845v-37.857a6.844 6.844 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M505.268 301.373h41.741v-14.651h-41.741z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M547.008 306.48h-41.74v14.651h41.74zM494.105 295.62c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M479.27 295.62c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464.423 295.62c2.333 0 4.225-1.856 4.225-4.146s-1.892-4.147-4.225-4.147c-2.334 0-4.226 1.857-4.226 4.147s1.892 4.146 4.226 4.146"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M494.105 309.652c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479.27 309.652c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#644AEC",
    d: "M464.423 309.652c2.333 0 4.225-1.856 4.225-4.146s-1.892-4.147-4.225-4.147c-2.334 0-4.226 1.857-4.226 4.147s1.892 4.146 4.226 4.146"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M414.586 311.771h24.655v-22.588h-24.655z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M549.338 345.931H410.084a6.845 6.845 0 0 0-6.845 6.845v37.857a6.845 6.845 0 0 0 6.845 6.845h139.254a6.845 6.845 0 0 0 6.845-6.845v-37.857a6.844 6.844 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M505.268 368.703h41.741v-14.651h-41.741z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M547.008 373.823h-41.74v14.651h41.74zM494.105 362.964c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M479.27 362.964c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464.423 362.964c2.333 0 4.225-1.857 4.225-4.147s-1.892-4.146-4.225-4.146c-2.334 0-4.226 1.856-4.226 4.146s1.892 4.147 4.226 4.147"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M494.105 376.996c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479.27 376.996c2.334 0 4.226-1.856 4.226-4.146s-1.892-4.147-4.226-4.147-4.225 1.857-4.225 4.147 1.892 4.146 4.225 4.146"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M464.423 376.996c2.333 0 4.225-1.856 4.225-4.146s-1.892-4.147-4.225-4.147c-2.334 0-4.226 1.857-4.226 4.147s1.892 4.146 4.226 4.146"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M414.586 379.115h24.655v-22.588h-24.655z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M549.338 413.273H410.084a6.845 6.845 0 0 0-6.845 6.845v37.858a6.845 6.845 0 0 0 6.845 6.845h139.254a6.845 6.845 0 0 0 6.845-6.845v-37.858a6.845 6.845 0 0 0-6.845-6.845",
    opacity: 0.3
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M505.268 436.046h41.741v-14.651h-41.741z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M547.008 441.167h-41.74v14.65h41.74zM494.105 430.307c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M479.27 430.307c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464.423 430.307c2.333 0 4.225-1.857 4.225-4.147s-1.892-4.146-4.225-4.146c-2.334 0-4.226 1.856-4.226 4.146s1.892 4.147 4.226 4.147"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M494.105 444.339c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479.27 444.339c2.334 0 4.226-1.857 4.226-4.147s-1.892-4.146-4.226-4.146-4.225 1.856-4.225 4.146 1.892 4.147 4.225 4.147"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7E8E0",
    d: "M464.423 444.339c2.333 0 4.225-1.857 4.225-4.147s-1.892-4.146-4.225-4.146c-2.334 0-4.226 1.856-4.226 4.146s1.892 4.147 4.226 4.147"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5D4",
    d: "M414.586 446.458h24.655V423.87h-24.655z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#373A74",
    d: "M447.771 422.185c-23.206 52.982-74.846 78.808-90.997 85.798a12.46 12.46 0 0 1-9.859 0c-16.165-6.99-67.831-32.816-91.038-85.798-22.088-50.428-24.049-99.053-23.944-116.692.027-4.252 2.501-8.122 6.45-10.083l107.913-53.588a12.5 12.5 0 0 1 11.07 0l107.873 53.588c3.949 1.961 6.424 5.831 6.45 10.07.105 17.638-1.856 66.263-23.944 116.692z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__e)",
    d: "M351.851 497.979a1 1 0 0 1-.395-.079c-14.519-6.279-63.579-30.604-85.245-80.059-21.114-48.23-23.141-94.578-23.023-112.282 0-.079.092-.211.29-.303l107.899-53.588c.171-.079.342-.105.461-.105.118 0 .289.013.46.105l107.873 53.588c.171.092.29.211.29.316.105 17.691-1.909 64.052-23.023 112.269-21.653 49.455-70.686 73.78-85.205 80.059a1.1 1.1 0 0 1-.395.079z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M384.299 366.662h-64.935v-39.595c0-17.467 14.493-31.684 32.303-31.684h.342c17.81 0 32.303 14.217 32.303 31.684v39.595zm-58.406-6.41h51.863v-33.185c0-13.94-11.557-25.273-25.76-25.273h-.342c-14.203 0-25.761 11.333-25.761 25.273z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M391.46 341.099h-79.256a9.16 9.16 0 0 0-9.162 9.162v67.053a9.16 9.16 0 0 0 9.162 9.162h79.256a9.16 9.16 0 0 0 9.161-9.162v-67.053a9.16 9.16 0 0 0-9.161-9.162"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#39AADA",
    d: "M365.001 376.022c0 5.502-3.514 10.201-8.45 12.07v14.717h-9.425v-14.717c-4.95-1.869-8.451-6.568-8.451-12.07 0-7.135 5.884-12.927 13.163-12.927s13.176 5.792 13.176 12.927z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M129.118 107H110v3.008h19.118zM145.294 107h-11.147v3.008h11.147zM143.064 114.898H110v3.008h33.064zM159.239 114.898h-11.146v3.008h11.146zM134.146 122.796H110v3.009h24.146zM159.238 122.796h-20.063v3.009h20.063zM142.168 130.694H110v3.009h32.168zM158.344 130.694h-11.147v3.009h11.147z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "m481.043 131.099-38.005-.594c-3.173-.048-4.822-2.924-3.671-6.424l13.757-41.839c1.151-3.5 4.66-6.29 7.833-6.241l38.005.594c3.173.048 4.822 2.924 3.671 6.424l-13.757 41.839c-1.151 3.499-4.66 6.289-7.833 6.241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M462.29 113.219c-.796-.01-1.505-.326-1.956-.94l-4.745-6.471c-.614-.834-.25-2.292.824-3.25s2.426-1.065 3.039-.23l4.401 6.001 20.258-16.49c1.103-.901 2.435-.901 2.972 0s.077 2.359-1.026 3.26l-20.881 16.998c-.93.757-1.975 1.131-2.886 1.122"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__f)",
    d: "M342.991 98.833v9.809c0 4.455 10.522 8.068 23.504 8.068s23.504-3.613 23.504-8.068v-9.809h-47.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__g)",
    d: "M366.495 106.901c12.981 0 23.504-3.612 23.504-8.067 0-4.456-10.523-8.068-23.504-8.068s-23.504 3.612-23.504 8.067c0 4.456 10.523 8.068 23.504 8.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__h)",
    d: "M342.991 84.45v9.81c0 4.455 10.522 8.067 23.504 8.067s23.504-3.612 23.504-8.067v-9.81h-47.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__i)",
    d: "M366.495 92.518c12.981 0 23.504-3.612 23.504-8.068s-10.523-8.067-23.504-8.067-23.504 3.612-23.504 8.067c0 4.456 10.523 8.068 23.504 8.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__j)",
    d: "M342.991 70.067v9.81c0 4.455 10.522 8.067 23.504 8.067s23.504-3.612 23.504-8.067v-9.81h-47.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__k)",
    d: "M366.495 78.135c12.981 0 23.504-3.612 23.504-8.068S379.476 62 366.495 62s-23.504 3.612-23.504 8.067c0 4.456 10.523 8.068 23.504 8.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__l)",
    d: "M317 114.567v9.809c0 4.455 10.522 8.068 23.504 8.068s23.504-3.613 23.504-8.068v-9.809H317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__m)",
    d: "M340.504 122.634c12.981 0 23.504-3.612 23.504-8.067 0-4.456-10.523-8.067-23.504-8.067S317 110.111 317 114.567s10.523 8.067 23.504 8.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__n)",
    d: "M317 100.184v9.809c0 4.455 10.522 8.067 23.504 8.067s23.504-3.612 23.504-8.067v-9.809H317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__o)",
    d: "M340.504 108.251c12.981 0 23.504-3.612 23.504-8.067 0-4.456-10.523-8.068-23.504-8.068S317 95.728 317 100.184s10.523 8.067 23.504 8.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__p)",
    d: "M317 85.8v9.81c0 4.455 10.522 8.067 23.504 8.067s23.504-3.612 23.504-8.067V85.8H317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__q)",
    d: "M340.504 93.868c12.981 0 23.504-3.612 23.504-8.067 0-4.456-10.523-8.068-23.504-8.068S317 81.345 317 85.801s10.523 8.067 23.504 8.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBFE",
    d: "M365.743 114.189c8.003 0 14.49-6.487 14.49-14.49s-6.487-14.49-14.49-14.49-14.49 6.487-14.49 14.49 6.487 14.49 14.49 14.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__r)",
    d: "M371.917 96.14h-12.348c-.805 0-1.457.652-1.457 1.457v9.197c0 .805.652 1.457 1.457 1.457h12.348c.806 0 1.457-.652 1.457-1.457v-9.197c0-.805-.651-1.457-1.457-1.457m-8.508 2.333a1.382 1.382 0 1 1-.002 2.764 1.382 1.382 0 0 1 .002-2.764m4.629 7.447a1.382 1.382 0 1 1 .002-2.764 1.382 1.382 0 0 1-.002 2.764m.014-4.671c-.175 0-.341-.035-.496-.092l-2.891 2.874q.096.238.097.507a1.381 1.381 0 1 1-.905-1.295l2.904-2.886a1.382 1.382 0 1 1 1.291.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#IntegratedSecurity_svg__s)",
    d: "M371.037 98.022a.94.94 0 0 1-.942-.942v-1.872a4.357 4.357 0 0 0-4.351-4.351 4.357 4.357 0 0 0-4.352 4.351v1.872a.941.941 0 1 1-1.883 0v-1.872a6.24 6.24 0 0 1 6.235-6.235 6.243 6.243 0 0 1 6.235 6.235v1.872c0 .52-.422.942-.942.942"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__a",
    x1: 366.1,
    x2: 355.032,
    y1: 575.923,
    y2: 545.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__b",
    x1: 908.253,
    x2: -54.882,
    y1: 187.394,
    y2: 485.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__c",
    x1: 431.691,
    x2: 112.634,
    y1: 262.147,
    y2: 319.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__d",
    x1: 324.841,
    x2: 608.422,
    y1: 406.793,
    y2: 356.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ABA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__e",
    x1: 362.034,
    x2: 231.81,
    y1: 253.298,
    y2: 673.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__f",
    x1: 376.054,
    x2: 373.272,
    y1: 117.856,
    y2: 97.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__g",
    x1: 372.449,
    x2: 360.54,
    y1: 110.347,
    y2: 87.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__h",
    x1: 376.054,
    x2: 373.272,
    y1: 103.473,
    y2: 83.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__i",
    x1: 372.449,
    x2: 360.54,
    y1: 95.963,
    y2: 72.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__j",
    x1: 376.054,
    x2: 373.272,
    y1: 89.09,
    y2: 68.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__k",
    x1: 372.449,
    x2: 360.54,
    y1: 81.581,
    y2: 58.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__l",
    x1: 350.063,
    x2: 347.281,
    y1: 133.59,
    y2: 113.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__m",
    x1: 346.457,
    x2: 334.549,
    y1: 126.079,
    y2: 103.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__n",
    x1: 350.063,
    x2: 347.281,
    y1: 119.206,
    y2: 98.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__o",
    x1: 346.457,
    x2: 334.549,
    y1: 111.697,
    y2: 88.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__p",
    x1: 350.063,
    x2: 347.281,
    y1: 104.823,
    y2: 84.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__q",
    x1: 346.457,
    x2: 334.549,
    y1: 97.314,
    y2: 74.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#315FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3866ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4472F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5683F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6D9AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__r",
    x1: 370.037,
    x2: 359.686,
    y1: 110.059,
    y2: 91.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#305EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3765ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4370F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5481F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6A96F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IntegratedSecurity_svg__s",
    x1: 372.866,
    x2: 362.515,
    y1: 108.514,
    y2: 89.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#305EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3765ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4370F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5481F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6A96F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ADFD"
  })))));
};
export default SvgIntegratedSecurity;